<template>
  <div
    class="flex flex-col md:flex-row gap-2 md:gap-5 justify-between py-3 md:py-0"
  >
    <span
      class="py-1 px-2 text-darken text-md font-normal leading-5 tracking-tight"
    >
      &copy; <span class="hidden md:inline-block">{{ currentYear }}</span>
      <span> Patchstack</span>
    </span>
    <BaseLink
      to="https://patchstack.com/data-processing-agreement-dpa/"
      class="terms-link"
      target="_blank"
      aria-label="Visit DPA"
      >DPA</BaseLink
    >
    <BaseLink
      to="https://patchstack.com/privacy-policy/"
      class="terms-link"
      target="_blank"
      aria-label="Visit Privacy Policy"
      >Privacy Policy</BaseLink
    >
    <BaseLink
      to="https://patchstack.com/terms-and-conditions/"
      class="terms-link"
      target="_blank"
      aria-label="Visit Terms & Conditions"
      >Terms &amp; Conditions</BaseLink
    >
    <BaseImage
      src="/images/eic-logo.png"
      alt="EU Flag"
      width="215"
      height="auto"
    />
  </div>
</template>

<script setup>
  const currentYear = new Date().getFullYear();
</script>
<style lang="scss" scoped>
  .terms-link {
    @apply py-1 px-2 text-darken text-md font-normal leading-5 tracking-tight hover:text-primary hover:bg-dark5 hover:bg-opacity-10 duration-400;
  }
</style>
